import { connect } from "react-redux";

import ResetPasswordEmailPage from "../components/login/ResetPasswordEmailPage";
import { sendResetPasswordEmailRequest } from "shared-frontend/redux/actions/resetPassword";
import { getResetPassword } from "../redux/selectors/ui/login";


export const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		attemptResetPasswordEmail: ( data ) => {
			dispatch( sendResetPasswordEmailRequest( data, ownProps ) );
		},
	};
};

export const mapStateToProps = ( state ) => {
	return getResetPassword( state );
};

const ResetPasswordContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)( ResetPasswordEmailPage );

export default ResetPasswordContainer;
